import React, { useCallback, useEffect, useState } from "react";
import styles from "./styles.module.css";
import clsx from "clsx";
import _noop from "lodash/noop";
import _isNil from "lodash/isNil";
import _isEmpty from "lodash/isEmpty";
import { WidgetItem } from "../../interfaces/TournamentsConfig";
import { getNxTimerText, showTimerTextNX } from "../../utils/helpers/TournamentNXUtils";
import { getCurrentTimestamp } from "../../utils/DateUtils";
import cargo from "../../utils/cargo";
import { useTranslation } from "react-i18next";

interface GameStatusNotchInterface {
  timeRemaining?: string;
  className?: string;
  tournament?: WidgetItem | undefined;
  // timerText?: string;
  textStyles?: object | undefined;
  containerStyles?: object | undefined;
  ignoreShowTimerFlag?: boolean;
  runWhenTimerReachesZero?: () => void;
}

const DELAY_IN_MILLIS = 1000;
const TIMER_EXPIRED_STRING = "EXPIRED";

const GameStatusNotch: React.FC<GameStatusNotchInterface> = ({
  timeRemaining,
  className,
  tournament,
  ignoreShowTimerFlag,
  // timerText ="",
  runWhenTimerReachesZero = _noop,
}) => {
  const {t} = useTranslation();
  const { timerText, textColor } = getNxTimerText(tournament, t)
  const [timer, setTimer] = useState<number | undefined>(undefined);
  const ltid = tournament?.ltid;
  const registrationStartTime = tournament?.registrationStartTime || 0;
  const registrationEndTime = tournament?.registrationEndTime || 0;
  // const showCountDownTimer = showTimerTextNX(tournament, ignoreShowTimerFlag);
  const showCountDownTimer= true
  const runSecondsTimer = useCallback(() => {
    if (!registrationStartTime || !registrationEndTime || !showCountDownTimer) {
      //Add log here
      return;
    }
    const currentTime = getCurrentTimestamp() as number;
    const timeToCompare =
      currentTime < registrationStartTime
        ? registrationStartTime
        : registrationEndTime;

    setTimer(Math.round(timeToCompare - getCurrentTimestamp()));
  }, [showCountDownTimer, registrationStartTime, registrationEndTime]);

  useEffect(() => {
    cargo.set(String(ltid), runSecondsTimer);
    return () => {
      cargo.purge(String(ltid));
    };
  }, [ltid, runSecondsTimer]);

  //Updating Timer text value
  let newTimerText = null;
  if (showCountDownTimer && timer) {
    let timerValue = "";
    if (timer / DELAY_IN_MILLIS <= 0) {
      // NEED TO BE CHECKED
      // timerValue = TIMER_EXPIRED_STRING;
      timerValue =''
    } else if (timer >= 24 * 60 * 60 * 1000) {
      // More than a day, show days and hours
      const days = Math.floor(timer / (24 * 60 * 60 * 1000));
      const hours = Math.floor(
        (timer % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000)
      );
      timerValue =
        days.toString() + "d " + hours.toString().padStart(2, "0") + "h";
    } else if (timer >= 60 * 60 * 1000) {
      // More than an hour, show hours and minutes
      const hours = Math.floor(timer / (60 * 60 * 1000));
      const mins = Math.floor((timer % (60 * 60 * 1000)) / (60 * 1000));
      timerValue =
        hours.toString().padStart(2, "0") +
        "h " +
        mins.toString().padStart(2, "0") +
        "m";
    } else {
      // Less than an hour, show minutes and seconds
      const mins = Math.floor(timer / (60 * 1000));
      const secs = Math.floor((timer % 60000) / 1000);
      timerValue =
        mins.toString().padStart(2, "0") +
        "m " +
        secs.toString().padStart(2, "0") +
        "s";
    }
    newTimerText = `${timerText} ${timerValue}`;
  }

  useEffect(() => {
    if (!_isNil(timer) && timer <= 0) {
      runWhenTimerReachesZero();
      cargo.purge(String(ltid));
    }
  }, [timer]);

  if (_isEmpty(newTimerText)) {
    return null;
  }

  return (
    <>
      <div
        className={clsx(
          styles.gamesStatus,
          className,
          "fontSizeXs fontWeightBold"
        )}
        style={{ color: textColor }} 
      >
        {newTimerText}
      </div>
    </>
  );
};
export default GameStatusNotch;
